import 'reflect-metadata';
import { Country } from '@order-mage/integration-sdk';
import { CountryIso2 } from 'react-international-phone';

const toIso2 = (country: Country): CountryIso2 => country.toLowerCase() as CountryIso2;

export const SUPPORTED_COUNTRIES = [
    Country.CZ,
    Country.SK,
    Country.GB,
    Country.US,
    Country.PL,
    Country.DE,
].map(toIso2);

const TIMEZONE_TO_COUNTRY: Record<string, Country> = {
    'Europe/Tirane': Country.AL,
    'Europe/Andorra': Country.AD,
    'Europe/Vienna': Country.AT,
    'Europe/Minsk': Country.BY,
    'Europe/Brussels': Country.BE,
    'Europe/Sarajevo': Country.BA,
    'Europe/Sofia': Country.BG,
    'Europe/Zagreb': Country.HR,
    'Asia/Nicosia': Country.CY,
    'Europe/Prague': Country.CZ,
    'Europe/Copenhagen': Country.DK,
    'Europe/Tallinn': Country.EE,
    'Europe/Helsinki': Country.FI,
    'Europe/Paris': Country.FR,
    'Europe/Berlin': Country.DE,
    'Europe/Athens': Country.GR,
    'Europe/Budapest': Country.HU,
    'Atlantic/Reykjavik': Country.IS,
    'Europe/Dublin': Country.IE,
    'Europe/Rome': Country.IT,
    'Europe/Riga': Country.LV,
    'Europe/Vaduz': Country.LI,
    'Europe/Vilnius': Country.LT,
    'Europe/Luxembourg': Country.LU,
    'Europe/Malta': Country.MT,
    'Europe/Chisinau': Country.MD,
    'Europe/Monaco': Country.MC,
    'Europe/Podgorica': Country.ME,
    'Europe/Amsterdam': Country.NL,
    'Europe/Skopje': Country.MK,
    'Europe/Oslo': Country.NO,
    'Europe/Warsaw': Country.PL,
    'Europe/Lisbon': Country.PT,
    'Europe/Bucharest': Country.RO,
    'Europe/Moscow': Country.RU,
    'Europe/Kaliningrad': Country.RU,
    'Europe/Samara': Country.RU,
    'Europe/San_Marino': Country.SM,
    'Europe/Belgrade': Country.RS,
    'Europe/Bratislava': Country.SK,
    'Europe/Ljubljana': Country.SI,
    'Europe/Madrid': Country.ES,
    'Europe/Stockholm': Country.SE,
    'Europe/Zurich': Country.CH,
    'Europe/Istanbul': Country.TR,
    'Europe/Kyiv': Country.UA,
    'Europe/Kiev': Country.UA,
    'Europe/London': Country.GB,
    'Europe/Vatican': Country.VA,
};

const LOCALE_TO_COUNTRY: Record<string, Country> = {
    sq: Country.AL,
    ca: Country.AD,
    de: Country.DE,
    be: Country.BY,
    nl: Country.NL,
    bs: Country.BA,
    bg: Country.BG,
    hr: Country.HR,
    el: Country.GR,
    cs: Country.CZ,
    da: Country.DK,
    et: Country.EE,
    fi: Country.FI,
    fr: Country.FR,
    hu: Country.HU,
    is: Country.IS,
    en: Country.GB,
    it: Country.IT,
    lv: Country.LV,
    lt: Country.LT,
    lb: Country.LU,
    mt: Country.MT,
    ro: Country.RO,
    sr: Country.RS,
    mk: Country.MK,
    no: Country.NO,
    nb: Country.NO,
    nn: Country.NO,
    pl: Country.PL,
    pt: Country.PT,
    ru: Country.RU,
    sk: Country.SK,
    sl: Country.SI,
    es: Country.ES,
    sv: Country.SE,
    tr: Country.TR,
    uk: Country.UA,
};

const FALLBACK_COUNTRY: CountryIso2 = SUPPORTED_COUNTRIES[0];

export const getDefaultCountry = (locale?: string): CountryIso2 => {
    if (typeof window !== 'undefined') {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const fromTz = TIMEZONE_TO_COUNTRY[tz];
        if (fromTz) {
            const iso = toIso2(fromTz);
            if (SUPPORTED_COUNTRIES.includes(iso)) {
                return iso;
            }
        }
    }

    const localePrefix = locale?.toLowerCase().split('-')[0];
    const fromLocale = localePrefix ? LOCALE_TO_COUNTRY[localePrefix] : undefined;
    if (fromLocale) {
        const iso = toIso2(fromLocale);
        if (SUPPORTED_COUNTRIES.includes(iso)) {
            return iso;
        }
    }

    return FALLBACK_COUNTRY;
};
